// F1 App-Shell (TES-948): Desktop Top App Bar (screen-04).
// h-16 border-b border-outline-variant. Breadcrumb-Slot + dekorative Suche
// (keine neue Datenquelle) + Action-Cluster (LayoutDebug/Language/Theme/
// NotificationBell/UserSwitcher-DEV). data-tour="notification-bell" erhalten.
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LanguageToggle } from "@/components/ui/language-toggle";
import { ThemeToggle } from "@/components/ui/theme-toggle";
import { NotificationBell } from "@/components/notifications/NotificationBell";
import { UserSwitcher } from "@/components/dev/UserSwitcher";
import { LayoutDebugToggle } from "@/components/admin/LayoutDebugHelper";
import { AppBreadcrumb } from "../AppBreadcrumb";

export function TopAppBar() {
  const { t } = useTranslation();

  // shrink-0 am <header> (TES-1683): verhindert, dass die h-16-Leiste in der flex-col `main`
  // (overflow-auto) den Overflow-Shrink content-schwerer Seiten (z.B. Dashboard) absorbiert und
  // schrumpft — sonst „springt" die Header-Höhe beim Navigieren.
  return (
    <header
      data-testid="top-app-bar"
      className="hidden md:flex shrink-0 sticky top-0 z-50 h-16 items-center justify-between gap-4 bg-surface border-b border-outline-variant px-4 sm:px-6"
    >
      <div className="min-w-0 flex-1 overflow-hidden">
        <AppBreadcrumb />
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        {/* Dekorative Suche (keine neue Datenquelle — F1 Out-of-Scope) */}
        <div className="relative hidden lg:block">
          <input
            type="search"
            disabled
            placeholder={t("common.search")}
            aria-label={t("common.search")}
            className="bg-surface-container-low border border-outline-variant px-4 py-1.5 rounded-full text-sm w-48 xl:w-64 focus:ring-1 focus:ring-primary focus:border-primary transition-all disabled:cursor-not-allowed"
          />
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 text-on-surface-variant h-4 w-4 pointer-events-none" />
        </div>
        <LayoutDebugToggle />
        <LanguageToggle />
        <ThemeToggle />
        <span data-tour="notification-bell">
          <NotificationBell />
        </span>
        {/* Dev toolbar - always shown in development mode */}
        {import.meta.env.DEV && <UserSwitcher />}
      </div>
    </header>
  );
}
